var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cliente-main","transition":"slide-x-transition"}},[_c('cliente-compras'),_c('cliente-wish-list'),_c('cliente-likes'),_c('cliente-historial')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }